import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import adharAccess_img from "../../../../assets/images/adhar-access.webp";
import { config } from "../../../../config/domain";
import EdModal from "../../../generic/edModal";
import Loader from "../../../generic/loader";
import TocDropdown from "../../../generic/tocDropdown";
import {
  generateAccessTokenDetails,
  getDocListFromDigilocker,
  getSelectedDocument,
  getDigiLockerDetails,
} from "../../../service/generic/otherApi";
import { getUserID } from "../../../service/login/loginService";
import {
  GetEquityReactivationClientValidation,
  getSelectedDocumentDetails,
} from "../../../service/serviceRequest/srApiService";
import { IListObj } from "../../../types/genericTypes";

var overflowBtnDropdownOptions: Array<IListObj> = [
  {
    value: "/clientarea/service-request/address-modification",
    display: "Address Modification",
  },
  {
    value: "/clientarea/service-request/account-reactivation",
    display: "Account Reactivation",
  },
];
var totalStage = [
  "Profile Details",
  "Address Details",
  "Bank Details",
  window.localStorage.getItem("digiAuthKey") ? "Document Upload ": "Document Upload & Video IPV",
  "E-sign",
];
export const ShowDocuments: React.FC<any> = (props) => {
  const RedirectnSource = window.localStorage.getItem("source");
  const location = useLocation();
  const [errCode, setErrCode] = React.useState<number | string>("");
  const [aadharDocDetails, setAadharDocDetails] = React.useState<any>();
  const [accessToken, setAccessToken] = React.useState<string>("");
  const [authToken, setAuthToken] = React.useState<any>("");
  const [authKey, setAuthKey] = React.useState<any>("");
  const [token, setToken] = React.useState<any>("");
  const [accountCode, setAccountCode] = React.useState<any>();
  const [panNo, setPanNo] = React.useState<any>();
  const [loader, setLoader] = React.useState(true);
  const srId = window.localStorage.getItem("srId");
  const source = window.localStorage.getItem("source");
  const consentType = localStorage.getItem("consentType");
  const addressConsent = localStorage.getItem("consent");
  const [showModel, setShowModel] = React.useState(true);
  const [fullName, setFullName] = React.useState<any>();
  let digieFlow: any = localStorage.getItem("digie");
  const [currentStage, setCurrentStage] = React.useState(2);
  const rejectFlow: any = localStorage.getItem("rejectFlow");
  React.useEffect(() => {
    getAddressDetails();
    if (
      localStorage.getItem("digiLockerToken") &&
      localStorage.getItem("digiAuthToken") &&
      localStorage.getItem("digiAuthKey")
    ) {
      setAuthToken(localStorage.getItem("digiAuthToken"));
      setAuthKey(localStorage.getItem("digiAuthKey"));
      setToken(localStorage.getItem("digiLockerToken"));
      setLoader(false);
    } else {
      setErrCode(123);
      setLoader(false);
    }
  }, []);
  async function getAddressDetails() {
    try {
      let addressDetails = await GetEquityReactivationClientValidation();
      if (addressDetails.result && addressDetails.result.length > 0) {
        setAccountCode(addressDetails.result[0].AccountCode);
        setPanNo(addressDetails.result[0].PANNo);
        setFullName(addressDetails.result[0].FullAcName);
      }
    } catch (e) {}
  }
  async function getAccessToken(accessTokenObj: any) {
    let resp = await generateAccessTokenDetails(accessTokenObj);
    if (resp && resp.data) {
      if (resp.data.access_token) {
        let digiDocInfo = { ...accessTokenObj };
        digiDocInfo.access_token = resp.data.access_token;
        setAccessToken(resp.data.access_token);
        getDocumentListFromDigilocker(digiDocInfo);
      } else {
        if (resp.data.eaadhaar === "N") setLoader(false);
        setErrCode(
          "Please link your aadhaar details with digilocker and refresh the page and click on continue to complete the process."
        );
      }
    } else {
      setLoader(false);
      setErrCode(1241);
    }
  }
  async function getDocumentListFromDigilocker(digiDocInfo: any) {
    let documentsResp = await getDocListFromDigilocker(digiDocInfo);
    if (
      documentsResp.data &&
      documentsResp.data.items &&
      documentsResp.data.items.length > 0
    ) {
      const adhar = documentsResp.data.items.filter(
        (x: any) => x.name === "Aadhaar Card"
      );
      if (adhar.length > 0) {
        setAadharDocDetails(adhar[0]);
        setLoader(false);
      }
    } else {
      setErrCode(1252);
      setLoader(false);
    }
  }
  async function redirectToPage() {
    try {
      setLoader(true);
      let data = {
        token: token,
        authToken: authToken,
        authKey: authKey,
      };
      try {
        let selectedDocumentResp = await getDigiLockerDetails(data);
        let _source = (RedirectnSource == "onep-sr" || RedirectnSource == "nsdl_onep") ? "onep-sr" : "ajs"
        if (
          selectedDocumentResp &&
          selectedDocumentResp.aadharName &&
          selectedDocumentResp.coresAddress &&
          selectedDocumentResp.state &&
          selectedDocumentResp.coresPincode &&
          selectedDocumentResp.permanentCity
        ) {
          var autoQC = "No";
          if (
            selectedDocumentResp.aadharName
              .toLowerCase()
              .match(fullName.toLowerCase())
          )
            autoQC = "Yes";
          else autoQC = "No";
          let tempAddr = selectedDocumentResp.coresAddress.replaceAll(",", " ");
          tempAddr = tempAddr.trim();
          tempAddr = tempAddr.replace(/\s+/g, " ");
          let personalDetails = {
            aadharName: selectedDocumentResp.aadharName,
            addressLine1: tempAddr,
            stateStr: selectedDocumentResp.state,
            pincode: selectedDocumentResp.coresPincode,
            city: selectedDocumentResp.permanentCity,
            isDigiLocker: true,
            fileData: selectedDocumentResp.pdfDetails,
            fileName: selectedDocumentResp.ftpAadharFileName,
            proof: "Aadhar card",
            autoQC: autoQC,
            accCode: getUserID(),
            photoDetails: selectedDocumentResp.photoDetails,
            pdfXMLResp: selectedDocumentResp.pdfXMLResp,
          };
          window.localStorage.setItem(
            "personalDetails",
            JSON.stringify(personalDetails)
          );
          if (rejectFlow && digieFlow) {
            history.push(
               `/clientarea/service-request/account-reactivation?rejected&source=${_source}`
            );
          } else if (digieFlow) {
            let consent =
              consentType && consentType !== null
                ? "?source=ajs&consentType=" + consentType
                : addressConsent
                ? `?source=${_source}&consent=Change of Address`
                : `?source=${_source}`;
            history.push(
              "/clientarea/service-request/account-reactivation" + consent
            );
          } else {
            if (srId) {
              window.localStorage.setItem("srId", srId);
            }
            history.push(
              `/clientarea/service-request/address-modification?soad=dig&source=${_source}`
            );
          }
          setLoader(false);
        } else {
          setErrCode(1252);
          setLoader(false);
        }
      } catch (e) {
        setErrCode(1252);
        setLoader(false);
      }
    } catch (e) {
      setErrCode(1252);
      setLoader(false);
    }
  }
  const onClose = () => {
    if (digieFlow) {
      let consent =
        consentType && consentType !== null
          ? "?consentType=" + consentType
          : addressConsent
          ? "?consent=Change of Address"
          : "";
      history.push(
        "/clientarea/service-request/account-reactivation" + consent
      );
    } else {
      if (source === "ajs")
        history.push("/clientarea/service-request?soad=dig&source=ajs");
      else {
        history.push("/clientarea/servicerequest");
      }
    }
    setLoader(false);
    setShowModel(false);
  };

  const history = useHistory();
  function ModalBody(): React.ReactElement {
    return (
      <div className="modal-dialog modal-dialog-centered common-modal-deisgn finalPopup">
        <div className="modal-content top-brdr-block">
          <div className="modal-header">
            <h4 className="modal-title">New Service Request</h4>
            {!(
              (consentType &&
                (consentType?.includes("email") ||
                  consentType?.includes("mobile") ||
                  consentType?.includes("emailMob"))) ||
              addressConsent?.includes("Change of Address")
            ) && (
              <div>
                {source === "ajs" ? (
                  <a
                    role="button"
                    href={
                      (RedirectnSource == "onep-sr" || RedirectnSource == "nsdl_onep")
                      ? config.onePlatformBase + "service-request" 
                      : config.rootUrl + "clientarea/servicerequest"
                    }
                    title="Close"
                    className="cancel"
                  >
                    <i className="edel-icon-close"></i>
                  </a>
                ) : (
                  <a
                    role="button"
                    title="Close"
                    className="cancel"
                    onClick={onClose}
                  >
                    <i className="edel-icon-close"></i>
                  </a>
                )}
              </div>
            )}
          </div>
          <div
            className="modal-body scrollableModal"
            id="custom_scrollBar"
            tabIndex={0}
          >
            <div className="custom--row">
              <div className="form-field custom-col noLeftPAdding">
                <label className="input-label">Request for</label>
                <TocDropdown
                  selectedValue={
                    digieFlow
                      ? overflowBtnDropdownOptions[1].value
                      : overflowBtnDropdownOptions[0].value
                  }
                  dropdownOptions={
                    overflowBtnDropdownOptions ? overflowBtnDropdownOptions : []
                  }
                  onSelect={(value) =>
                    value !== "" ? props.history.push(value) : null
                  }
                  disabled={true}
                  isSearchable={false}
                />
              </div>
              {digieFlow ? (
                <div className="custom-col progressbarCol">
                  <div>
                    <ul className="progressbar">
                      {totalStage.map((stage, index) => {
                        if (currentStage - 1 >= index) {
                          return (
                            <li className="active">
                              <span className="edel-icon-tick"></span>
                            </li>
                          );
                        } else {
                          return <li></li>;
                        }
                      })}
                    </ul>
                  </div>

                  <div>
                    <p className="field-subHead bold-text text-center">
                      {totalStage[currentStage - 1]}
                    </p>
                  </div>
                </div>
              ) : (
                <div className="custom-col"></div>
              )}
            </div>

            <div className="adharSecWrap mainInnerBox">
              <div className="adharSec">
                <div className="image">
                  <img
                    src={adharAccess_img}
                    alt="Adhar access"
                    className="adharImg"
                  />
                </div>
                <h5 className="field-head text-center head">
                  Allow Access To Your Aadhar{" "}
                </h5>
                <div className="text">
                  <p className="text-center showDocTxt">
                    Click on confirm below to share a digital copy of your
                    Aadhaar card with us.
                  </p>
                  <p className="text-center digi-adhar-note  showDocTxt allowPageNote">
                    <span>Please note: </span>Digilocker does not reveal 12
                    digit Aadhaar Number to us.
                  </p>
                </div>
                {errCode && (
                  <div>
                    {typeof errCode === "number" ? (
                      <div className="digiLockerRedSec">
                        <p className="error-msg">
                          Looks like there might be an issue with DigiLocker,
                          would you like to try again or continue without
                          DigiLocker?
                        </p>
                      </div>
                    ) : (
                      <div className="digiLockerRedSec">
                        <label className="error-msg">{errCode}</label>
                      </div>
                    )}
                  </div>
                )}
                {loader && (
                  <div>
                    <Loader size={50} color="blue"></Loader>
                  </div>
                )}{" "}
                {errCode && !loader ? (
                  <>
                    <div className="button">
                      <button
                        type="button"
                        className=" common_button block_btn"
                        onClick={() => {
                          if (rejectFlow && digieFlow) {
                            localStorage.removeItem("digie");
                            localStorage.setItem("digieResubmit", "Yes");
                            let _source = (RedirectnSource == "onep-sr" || RedirectnSource == "nsdl_onep") ? "onep-sr" : "ajs"
                            history.push(
                              `/clientarea/service-request/account-reactivation?rejected&source=${_source}`
                            );
                          } else if (digieFlow) {
                            localStorage.removeItem("digie");
                            let consent =
                              consentType && consentType !== null
                                ? "?consentType=" + consentType
                                : addressConsent
                                ? "?consent=Change of Address"
                                : "";
                            history.push(
                              "/clientarea/service-request/account-reactivation" +
                                consent
                            );
                          } else {
                            if (srId) {
                              window.localStorage.removeItem("srId");
                              window.location.href =
                                (RedirectnSource == "onep-sr" || RedirectnSource == "nsdl_onep")
                                ? config.onePlatformBase + "service-request" 
                                : config.rootUrl + "clientarea/servicerequest"
                            } else {
                              let source = (RedirectnSource == "onep-sr" || RedirectnSource == "nsdl_onep") ? "onep-sr" : "ajs"
                              history.push(
                                `/clientarea/service-request/address-modification?source=${source}`
                              );
                            }
                          }
                        }}
                      >
                        Try Again
                      </button>
                    </div>
                    <div className="digiLockerLink">
                      <a
                        onClick={() => {
                          if (rejectFlow && digieFlow) {
                            localStorage.setItem("digie", "No");
                            localStorage.removeItem("digieResubmit");
                            let _source = (RedirectnSource == "onep-sr" || RedirectnSource == "nsdl_onep") ? "onep-sr" : "ajs"
                            history.push(
                              `/clientarea/service-request/account-reactivation?rejected&source=${_source}`
                            );
                          } else if (digieFlow) {
                            localStorage.setItem("digie", "No");
                            let consent =
                              consentType && consentType !== null
                                ? "?consentType=" + consentType
                                : addressConsent
                                ? "?consent=Change of Address"
                                : "";
                            history.push(
                              "/clientarea/service-request/account-reactivation" +
                                consent
                            );
                          } else {
                            if (srId) {
                              window.localStorage.setItem("srId", srId);
                            }
                            let _source = (RedirectnSource == "onep-sr" || RedirectnSource == "nsdl_onep") ? "onep-sr" : "ajs"
                            history.push(
                              `/clientarea/service-request/address-modification?soad=nondig&source=${_source}`
                            );
                          }
                        }}
                        className="blue-text"
                      >
                        Continue Without Digilocker
                      </a>
                    </div>
                  </>
                ) : (
                  <div>
                    {!loader && (
                      <>
                        <div className="button">
                          <button
                            type="button"
                            className=" common_button block_btn"
                            onClick={() => {
                              redirectToPage();
                            }}
                          >
                            Confirm
                          </button>
                        </div>
                        <div className="digiLockerLink">
                          <a
                            onClick={() => {
                              {
                                setShowModel(false);
                                if (rejectFlow && digieFlow) {
                                  localStorage.setItem("digie", "No");
                                  window.localStorage.removeItem(
                                    "digieResubmit"
                                  );
                                  let _source = (RedirectnSource == "onep-sr" || RedirectnSource == "nsdl_onep") ? "onep-sr" : "ajs"
                                  history.push(
                                    `/clientarea/service-request/account-reactivation?rejected&source=${_source}`
                                  );
                                } else if (digieFlow) {
                                  localStorage.setItem("digie", "No");
                                  let consent =
                                    consentType && consentType !== null
                                      ? "?consentType=" + consentType
                                      : addressConsent
                                      ? "?consent=Change of Address"
                                      : "";
                                  history.push(
                                    "/clientarea/service-request/account-reactivation" +
                                      consent
                                  );
                                } else {
                                  if (srId) {
                                    window.localStorage.setItem("srId", srId);
                                  }
                                  let _source = (RedirectnSource == "onep-sr" || RedirectnSource == "nsdl_onep")? "onep-sr" : "ajs"
                                  history.push(
                                    `/clientarea/service-request/address-modification?soad=nondig&source=${_source}`
                                  );
                                }
                              }
                            }}
                            className="blue-text"
                          >
                            Continue Without Digilocker
                          </a>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <EdModal
      show={showModel}
      close={() => {}}
      children={ModalBody()}
      modalClsNm={"absoluteModal"}
    />
  );
};
